module.exports = __webpack_public_path__ + "static/img/img_kaifaanli3.c7ff8f71.png";